import repository from "@/api/Seguridad.js";

export default {
  autenticar(usuario, contrasena, dispositivo) {
    debugger; //eslint-disable-line     
    let url = `/autenticar/`;
    let body = { usuario, contrasena, dispositivo };
    return repository.post(url, body);
  }
};
